import { toast } from "react-toastify";

function copyUrl(id, successMessage) {
  try {
    /* Get the text field */
    var copyText = document.getElementById(id);

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    navigator.clipboard.writeText(copyText.value);

    if (successMessage) {
      toast(successMessage);
    }
  } catch (err) {
    console.error(err);
  }
}
function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

const dateToString = (date, locale = "en-us") => {
  const jsDate = new Date(date);
  const offset = new Date().getTimezoneOffset();
  jsDate.setMinutes(jsDate.getMinutes() + offset);
  return jsDate.toLocaleDateString(locale, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const pastelColors = [
  "#F7A4A4",
  "#FEBE8C",
  "#FFFBC1",
  "#B6E2A1",
  "#FEE2B3",
  "#FFA299",
  "#AD6989",
  "#562349",
  "#876445",
  "#CA965C",
  "#EEC373",
  "#F4DFBA",
];
const add_https = (site) => {
  if (site !== "" && !site.includes("https://")) {
    site = "https://" + site;
  }
  return site;
};
const CFImageUrl = (imgUrl, height) => {
  if (imgUrl) {
    const { pathname, origin } = new URL(imgUrl);
    return `${origin}/cdn-cgi/image/height=${height}${pathname}`;
  }
};

function removeSlash(theString) {
  return theString.replace(/^\/|\/$/g, "");
}

const isNotificationSupported = () =>
  "Notification" in window &&
  "serviceWorker" in navigator &&
  "PushManager" in window;

const getVideoType = (url, mime_type) => {
  if (url.endsWith(".m3u8")) return "application/x-mpegURL";
  else return mime_type;
};

const isMobile = /iPhone|Android/i.test(navigator.userAgent);

// Check if Chrome Desktop (File System Access API) is supported
const isChromeDesktopSupported = () => {
  const isSecureContext =
    window.isSecureContext ||
    window.location.protocol === "https:" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const hasAPI =
    "showDirectoryPicker" in window &&
    typeof window.showDirectoryPicker === "function";

  return isSecureContext && hasAPI;
};

const truncateError = (error, maxLength = 40) => {
  if (!error) return "";
  if (error.length <= maxLength) return error;
  return error.substring(0, maxLength) + "...";
};

const truncateName = (name) => {
  if (!name) return "";
  if (name.length <= 20) return name;
  return name.substring(0, 10) + "..." + name.substring(name.length - 15);
};

/**
 * Creates a placeholder base64 black image URL
 * @returns {string} - Base64 encoded 1x1 black pixel
 */
const createPlaceholderImage = () => {
  return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAHUlEQVR42mP8z/D/PwMDAwMjI4GBgYGJgQEAOwQF/uKn+5EAAAAASUVORK5CYII=";
};

/**
 * Capitalizes the first letter of a string (sentence case)
 * @param {string} str - String to capitalize
 * @returns {string} String with first letter capitalized
 */
const capitalizeFirst = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const sanitizeFilename = (filename) => {
  if (!filename || typeof filename !== "string") return filename;


  /* eslint-disable no-control-regex */
  let sanitized = filename
    .replace(/[/\\?%*:|"<>]/g, "_")
    .replace(/[\x00-\x1f]/g, "_");
  /* eslint-enable no-control-regex */

  const reservedNames = /^(con|prn|aux|nul|com[1-9]|lpt[1-9])(\..*)?$/i;
  if (reservedNames.test(sanitized)) {
    sanitized = "_" + sanitized;
  }

  sanitized = sanitized.replace(/[. ]+$/, "");

  if (!sanitized || sanitized.match(/^[.]+$/)) {
    sanitized = "image_" + Math.random().toString(36).substring(7);
  }

  return sanitized;
};

export {
  copyUrl,
  formatBytes,
  randomIntFromInterval,
  dateToString,
  add_https,
  CFImageUrl,
  pastelColors,
  removeSlash,
  isNotificationSupported,
  getVideoType,
  isChromeDesktopSupported,
  isMobile,
  createPlaceholderImage,
  truncateError,
  truncateName,
  capitalizeFirst,
  sanitizeFilename,
};
